import Vue from 'vue';
import App from './App.vue';
import router from './router';
import '@/style/all.styl';
import { getInfos } from '@/apis/common';
import { showLoading, hideLoading } from '@/services/utils';
import moment from 'moment';
import Message from 'kpc/components/message';
import Dialog from 'kpc/components/dialog';
Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.prototype.showLoading = showLoading;
Vue.prototype.hideLoading = hideLoading;
Vue.prototype.globalData = {};
Vue.prototype.Message = Message;
Vue.prototype.Dialog = Dialog;
Vue.prototype.$EventBus = new Vue();
Vue.prototype.$moment = moment;
//定义一个全局过滤器实现日期格式化
Vue.filter('datefmt', function(input, fmtstring = 'YYYY-MM-DD HH:mm:ss') {
  if (!input) {
    return '-';
  }
  //当input为时间戳时，需转为Number类型
  // 使用momentjs这个日期格式化类库实现日期的格式化功能
  fmtstring = fmtstring ? fmtstring.replace(/y/g, 'Y').replace(/d/g, 'D') : '';
  let res = moment(input).format(fmtstring);
  if (res === 'Invalid date') {
    return '-';
  }
  return res;
});
const init = async () => {
  await getInfos();

  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app .main-wrapper');
};
init();
